import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  IconRegularCart,
  IconRegularGift,
  IconRegularLipstick,
  IconRegularPercent,
} from '@notino/react-styleguide';

import { loyaltyMessages } from '../../../messages';

import {
  DrawerContentWrapper,
  Title,
  BenefitsList,
  BenefitItem,
  BenefitContent,
  BenefitTitle,
  BenefitDescription,
} from './styled';

const benefits = [
  {
    id: 'pointsPerPurchase',
    icon: IconRegularCart,
    title: loyaltyMessages.pointsPerPurchase,
    description: loyaltyMessages.pointsPerPurchaseDescription,
  },
  {
    id: 'extraPointsForActivity',
    icon: IconRegularLipstick,
    title: loyaltyMessages.extraPointsForActivity,
    description: loyaltyMessages.extraPointsForActivityDescription,
  },
  {
    id: 'rewardsForPoints',
    icon: IconRegularGift,
    title: loyaltyMessages.rewardsForPoints,
    description: loyaltyMessages.rewardsForPointsDescription,
  },
  {
    id: 'specialDiscounts',
    icon: IconRegularPercent,
    title: loyaltyMessages.specialDiscounts,
    description: loyaltyMessages.specialDiscountsDescription,
  },
];

export const Content = () => {
  return (
    <DrawerContentWrapper>
      <Title typography="titleLarge">
        <FormattedMessage {...loyaltyMessages.drawerAndModalTitle} />
      </Title>

      <BenefitsList>
        {benefits.map((benefit, index) => {
          const IconComponent = benefit.icon;
          const isLast = index === benefits.length - 1;

          return (
            <BenefitItem key={benefit.id}>
              <IconComponent width="24px" height="24px" />

              <BenefitContent $isLast={isLast}>
                <BenefitTitle typography="bodyRegular">
                  <FormattedMessage {...benefit.title} />
                </BenefitTitle>
                <BenefitDescription typography="labelRegular400">
                  <FormattedMessage {...benefit.description} />
                </BenefitDescription>
              </BenefitContent>
            </BenefitItem>
          );
        })}
      </BenefitsList>
    </DrawerContentWrapper>
  );
};
